import React from 'react';
import { useSelector } from 'react-redux';
import { Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// Helper to check if current time is within a UTC window
const isWithinUtcWindow = (startUtc, endUtc) => {
  if (!startUtc || !endUtc) return false;
  const start = new Date(startUtc.endsWith('Z') ? startUtc : startUtc + 'Z');
  const end = new Date(endUtc.endsWith('Z') ? endUtc : endUtc + 'Z');
  const now = new Date();
  return now.getTime() >= start.getTime() && now.getTime() <= end.getTime();
};

const TppNavBar = () => {
  const { t } = useTranslation('navigation');
  const currentUser = useSelector((state) => state.currentUser);
  const settings = useSelector((state) => state.settings);

  // Checks if a navbar link should be active
  const checkActiveNavBarLink = (activeLink) => {
    return window.location.pathname.includes(activeLink);
  };

  // Only show if current UTC time is within the window defined by the dates
  const isAssignmentsRouteVisible = () => {
    const { acceptDeclineStartDate, acceptDeclineEndDate } = settings;
    if (!acceptDeclineStartDate || !acceptDeclineEndDate) return false;
    return isWithinUtcWindow(acceptDeclineStartDate, acceptDeclineEndDate);
  };

  const isInterestFormRouteVisible = () => {
    const { applyStartDate, applyEndDate } = settings;
    if (!applyStartDate || !applyEndDate) return false;
    return isWithinUtcWindow(applyStartDate, applyEndDate);
  };

  return (
    <Nav className="tpp-navbar mx-auto">
      <Nav.Item>
        <Nav.Link href="/mtp/profile" active={checkActiveNavBarLink('/mtp/profile')}>
          <i className="bi bi-person me-1" />
          {t('profile')}
        </Nav.Link>
      </Nav.Item>

      {isInterestFormRouteVisible() && (
        <Nav.Item>
          <Nav.Link href="/mtp/rep-work-application" active={checkActiveNavBarLink('/mtp/rep-work-application')}>
            <i className="bi bi-file-earmark-text me-1" />
            {t('interestForm')}
          </Nav.Link>
        </Nav.Item>
      )}

      {isAssignmentsRouteVisible() && (
        <Nav.Item>
          <Nav.Link href="/mtp/assignments" active={checkActiveNavBarLink('/mtp/assignments')}>
            <i className="bi bi-briefcase me-1" />
            {t('assignments')}
          </Nav.Link>
        </Nav.Item>
      )}

      {currentUser.isManager && settings.commentsOpen === 'Yes' && (
        <Nav.Item>
          <Nav.Link href="/mtp/manage-rep" active={checkActiveNavBarLink('/mtp/manage-rep')}>
            <i className="bi bi-people me-1" />
            {t('manageRep')}
          </Nav.Link>
        </Nav.Item>
      )}
    </Nav>
  );
};

export default TppNavBar;
